import { render, staticRenderFns } from "./MemberVotingDashboard.vue?vue&type=template&id=deaae866&scoped=true"
import script from "./MemberVotingDashboard.vue?vue&type=script&lang=js"
export * from "./MemberVotingDashboard.vue?vue&type=script&lang=js"
import style0 from "./MemberVotingDashboard.vue?vue&type=style&index=0&id=deaae866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaae866",
  null
  
)

export default component.exports